import req from 'utils/req';

export const LanguageClient = {
  setPreferredLanguage: (langCode) => {
    return req(`${URL_API_HOST}/api/v1/languages/preferred/${langCode}`).put();
  },
  setImplicitLanguage: (langCode) => {
    return req(`${URL_API_HOST}/api/v1/languages/implicit/${langCode}`).put();
  },
};
